import {
  GET_ZOHOCRM_INFO,
  SAVE_ZOHOCRM_INFO,
  SEND_LEADSQUARED_INFO,
  SEND_HUBSPOT_INFO,
  GET_LEADSQUARED_INFO,
  GET_HUBSPOT_INFO,
  SAVE_LEADSQUARED_INFO,
  SAVE_HUBSPOT_INFO,
  GET_LSQ_WHATSAPP_CONNECTOR,
  SAVE_LSQ_WHATSAPP_CONNECTOR,
  GET_ZOHO_DESK_INFO,
  SAVE_ZOHO_DESK_INFO,
  GET_GOOGLESHEETS_INFO,
  SAVE_GOOGLESHEETS_INFO,
} from "../constants/MarketPlace";

const initialState = {
  loading: true,
  hubspotLoading: true,
  zohoCRMLoading: true,
  googleSheetsLoading: true,
  zohoDeskloading: true,
  getLsFormData: {},
  getHbFormData: {},
  getConnectorData: {},
  getZohoCRMData: {},
  getZohoDeskData: {},
  getGoogleSheetsData: {},
};

const marketPlace = (state = initialState, action) => {
  switch (action.type) {
    case SEND_LEADSQUARED_INFO: {
      return {
        ...state,
        lsFormData: action.payload,
      };
    }
    case GET_LEADSQUARED_INFO: {
      return {
        ...state,
        loading: true,
      };
    }
    case SAVE_LEADSQUARED_INFO: {
      return {
        ...state,
        loading: false,
        getLsFormData: action.payload,
      };
    }
    case SEND_HUBSPOT_INFO: {
      return {
        ...state,
        hbFormData: action.payload,
      };
    }
    case GET_HUBSPOT_INFO: {
      return {
        ...state,
        hubspotLoading: true,
      };
    }
    case SAVE_HUBSPOT_INFO: {
      return {
        ...state,
        hubspotLoading: false,
        getHbFormData: action.payload,
      };
    }
    case GET_LSQ_WHATSAPP_CONNECTOR: {
      return {
        ...state,
      };
    }
    case SAVE_LSQ_WHATSAPP_CONNECTOR: {
      return {
        ...state,
        getConnectorData: action.payload,
      };
    }
    case GET_ZOHOCRM_INFO: {
      return {
        ...state,
        zohoCRMLoading : true,
      };
    }
    case SAVE_ZOHOCRM_INFO: {
      return {
        ...state,
        zohoCRMLoading : false,
        getZohoCRMData: action.payload,
      };
    }
    case GET_GOOGLESHEETS_INFO: {
      return {
        ...state,
        googleSheetsLoading : true,
      };
    }
    case SAVE_GOOGLESHEETS_INFO: {
      return {
        ...state,
        googleSheetsLoading : false,
        getGoogleSheetsData: action.payload,
      };
    }
    case GET_ZOHO_DESK_INFO: {
      return {
        ...state,
        zohoDeskloading: true,
      };
    }
    case SAVE_ZOHO_DESK_INFO: {
      return {
        ...state,
        zohoDeskloading: false,
        getZohoDeskData: action.payload,
      };
    }
    default:
      return state;
  }
};

export default marketPlace;
